import React from 'react';
import useRedirectUrl from 'hooks/useRedirectUrl';

const DEFAULT_COUNTDOWN_SECONDS = 20;

export default function TopRedirectBanner({ seconds = DEFAULT_COUNTDOWN_SECONDS }) {
  const [remainingSeconds, setRemainingSeconds] = React.useState(seconds);

  const url = useRedirectUrl();

  React.useEffect(() => {
    if (!url) {
      return;
    }
    const intervalId = window.setInterval(() => {
      setRemainingSeconds((previous) => {
        if (previous <= 1) {
          window.clearInterval(intervalId);
          window.location.href = url;
          return 0;
        }
        return previous - 1;
      });
    }, 1000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [url]);

  const handleGoNowClick = () => {
    window.location.href = url;
  };

  // nibble
  if (!url) {
    return (
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 10001,
          background: '#111827',
          color: '#ffffff',
          padding: '10px 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}
        role="region"
        aria-label="Redirect notice"
      >
        <div style={{
          display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
        }}
        >
          Omnicart will undergo maintenance from Sunday, Oct 5th at 10:30 PM PST through Monday, Oct 6th at 6:00 AM PST.
          During this time, the system will be temporarily inaccessible.
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 10001,
        background: '#111827',
        color: '#ffffff',
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}
      role="region"
      aria-label="Redirect notice"
    >
      <div style={{
        display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
      }}
      >
        <span style={{ fontWeight: 600 }}>We have moved!</span>
        <span>
          Please use our new admin at
          {' '}
          <a href={url} style={{ color: '#60A5FA', textDecoration: 'underline' }}>
            {new URL(url).host}
          </a>
          . You will be redirected in
          {' '}
          {remainingSeconds}
          s.
        </span>
      </div>
      <button
        type="button"
        onClick={handleGoNowClick}
        style={{
          background: '#60A5FA',
          color: '#0B1220',
          border: 'none',
          padding: '6px 12px',
          borderRadius: 6,
          cursor: 'pointer',
          fontWeight: 600,
        }}
      >
        Go now
      </button>
    </div>
  );
}
